import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import PropertyName from 'automation-ui-references/object-type-properties/PropertyName';
import * as CRMObjectTypes from 'automation-ui-references/object-types/CRMObjectTypes';
import { AnchorDelayDirectionType } from 'automation-ui-action-features/actions/classic-anchored-delay/constants/AnchorDelayDirectionType';
import { jsx as _jsx } from "react/jsx-runtime";
const ClassicAnchoredDelayActionDetail = ({
  actionMetadata,
  messageLangPath = 'actionDetail',
  eventAnchor,
  recurAnnually
}) => {
  const {
    direction
  } = actionMetadata;
  const delta = actionMetadata.delay.delta;
  const {
    hour,
    minute
  } = actionMetadata.delay.timeOfDay;
  const {
    contactPropertyAnchor,
    staticDateAnchor
  } = eventAnchor;
  let date = '';
  if (contactPropertyAnchor) {
    date = /*#__PURE__*/_jsx(PropertyName, {
      objectTypeId: CRMObjectTypes.CONTACT_ID,
      propertyName: contactPropertyAnchor
    });
  } else if (staticDateAnchor) {
    date = /*#__PURE__*/_jsx(FormattedDateTime, {
      value: new Date(staticDateAnchor),
      format: recurAnnually ? 'short-date' : 'll',
      type: "userTz"
    });
  } else {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.action-features.classic-anchored-delay.prompt"
    });
  }
  const dateTime = new Date(new Date(new Date().setHours(hour)).setMinutes(minute));
  const options = {
    date: /*#__PURE__*/_jsx(Text, {
      as: "strong",
      typography: "heading-50",
      children: date
    }),
    count: delta,
    time: /*#__PURE__*/_jsx(Text, {
      as: "strong",
      typography: "heading-50",
      children: /*#__PURE__*/_jsx(FormattedDateTime, {
        value: dateTime,
        format: "LT",
        type: "userTz"
      })
    })
  };

  // Avoiding dynamic language keys
  if (messageLangPath === 'actionDetail') {
    if (direction === AnchorDelayDirectionType.BEFORE) {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-action-features.action-features.classic-anchored-delay.action-detail.before",
        options: options
      });
    }
    return delta ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.classic-anchored-delay.action-detail.after",
      options: options
    }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.classic-anchored-delay.action-detail.onDate",
      options: options
    });
  } else {
    if (direction === AnchorDelayDirectionType.BEFORE) {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-action-features.action-features.classic-anchored-delay.action-preview.before",
        options: options
      });
    }
    return delta ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.classic-anchored-delay.action-preview.after",
      options: options
    }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.classic-anchored-delay.action-preview.onDate",
      options: options
    });
  }
};
export default ClassicAnchoredDelayActionDetail;